<template lang="pug">
#content.snap-content
  .overlay(@click="hide()")
  Marquee(:class="{ 'd-none': !whiteLabel }")
  toolBar
  customizeSportsOrderPanel(:order="order" @onUpdate="updateSportsOrder")
  footerNav
</template>


<script>
import toolBar from "@/components/mobile/toolBar";
import customizeSportsOrderPanel from "@/components/mobile/account/customizeSportsOrderPanel";
import footerNav from "@/components/mobile/footerNav";
import Marquee from "@/components/mobile/mainPanelControl/marquee";
import config from "@/config";

export default {
  components: {
    toolBar,
    customizeSportsOrderPanel,
    footerNav,
    Marquee
  },
  data() {
    return {
      order: []
    };
  },
  computed: {
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    defineOrder() {
      return this.$store.state.layout.order.sports;
    },
    defaultOrder() {
      return Object.keys(this.$store.state.layout.sports);
    }
  },
  mounted() {
    if (this.defineOrder.length > 0) {
      this.order = this.defineOrder;
    } else {
      this.order = this.defaultOrder;
    }
  },
  methods: {
    hide(e) {
      var body = $("body");
      if (body.hasClass("snapjs-left")) {
        body.removeClass("snapjs-left");
      }
    },
    updateSportsOrder(e) {
      this.order = e;
      this.save();
    },
    save() {
      this.$store.dispatch("layout/setOrder", { property: "sports", value: this.order });
      // this.$router.push("/settings");
    }
  }
};
</script>
